import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

import { useProps, useClassName } from 'components/pure/hooks';

const propTypes = {}
const imutableProps = {}
const mutableProps = {}

const classNames = {
  default: 'formBuilder__fieldIcon',
}

export default function InfoIcon({ children, className, ...props }) {
  className = useClassName(classNames, className)

  return <span {...useProps(props, imutableProps)} className={className}>
    <FontAwesome icon={faInfoCircle} />
  </span>
}

InfoIcon.propTypes = propTypes
InfoIcon.defaultProps = mutableProps
